import './styles/footer.scss'
import React from 'react'
import { useState } from 'react'

function Footer() {
    const [email, setEmail] = useState('')

    return (
        <footer className='footer-container'>
            <div className='footer-content'>
                <div className='social'>
                    <a
                        href='https://twitter.com/nisamerica'
                        target='_blank'
                        rel='noreferrer'
                        className='track-link'
                        data-label='Twitter'
                    >
                        <i className='fab fa-twitter btn'></i>
                    </a>
                    <a
                        href='https://www.facebook.com/NISAmericaInc/'
                        target='_blank'
                        rel='noreferrer'
                        className='track-link'
                        data-label='Facebook'
                    >
                        <i className='fab fa-facebook-f btn'></i>
                    </a>
                    <a
                        href='https://www.instagram.com/nisamerica/'
                        target='_blank'
                        rel='noreferrer'
                        className='track-link'
                        data-label='Instagram'
                    >
                        <i className='fab fa-instagram btn'></i>
                    </a>
                    <span style={{ whiteSpace: 'nowrap' }}>
                        <a
                            href='https://www.youtube.com/user/NISAmerica'
                            target='_blank'
                            rel='noreferrer'
                            className='track-link'
                            data-label='YouTube'
                        >
                            <i className='fab fa-youtube btn'></i>
                        </a>
                        <a
                            href='https://www.twitch.tv/nisamerica'
                            target='_blank'
                            rel='noreferrer'
                            className='track-link'
                            data-label='Twitch'
                        >
                            <i className='fab fa-twitch btn'></i>
                        </a>
                        <a
                            href='https://discord.gg/nisa'
                            target='_blank'
                            rel='noreferrer'
                            className='track-link'
                            data-label='Discord'
                        >
                            <i className='fab fa-discord btn'></i>
                        </a>
                    </span>
                </div>

                <div className='mailchimp'>
                    <form
                        action='https://nisamerica.us11.list-manage.com/subscribe/post?u=e8fc423eff95099d1ffcc6009&amp;id=349f7d20f9'
                        method='post'
                        id='mc-embedded-subscribe-form'
                        name='mc-embedded-subscribe-form'
                        className='validate'
                        target='_blank'
                        noValidate=''
                    >
                        <div id='mc_embed_signup_scroll' className='mailchimp'>
                            <label for='mce-EMAIL' className='subscribe'>
                                Subscribe to our mailing list to get the latest information!
                            </label>
                            <div className='interact'>
                                <input
                                    type='email'
                                    value={email}
                                    name='EMAIL'
                                    className='email'
                                    id='mce-EMAIL'
                                    placeHolder='email address'
                                    required=''
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <div style={{ position: ' absolute', left: '-5000px' }}>
                                    <input
                                        type='text'
                                        name='b_e8fc423eff95099d1ffcc6009_349f7d20f9'
                                        tabindex='-1'
                                        value=''
                                    />
                                </div>
                                <input type='hidden' value='cruelking' name='SIGNSITE' className='' id='mce-SIGNSITE' />
                                <div className='clear'>
                                    <input
                                        type='submit'
                                        value='Subscribe'
                                        name='subscribe'
                                        id='mc-embedded-subscribe'
                                        className='button'
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div className='logos'>
                    <span className='esrb'>
                        <img
                            src={`${process.env.PUBLIC_URL}/img/footer/rating.svg`}
                            alt='ESRB RATING'
                            className='f-logo'
                            id='ESRB'
                            height='80'
                        />
                    </span>{' '}
                    <span className='esrb'>
                        <img
                            src='https://nisamerica.com/public/assets/logo/ps4-ps5.svg'
                            alt='PS4'
                            className='f-logo'
                            id='PS45'
                        />

                        <img
                            src='https://nisamerica.com/public/assets/logo/nsw-nsw2-red.png'
                            alt='NSW'
                            className='f-logo'
                            id='NSW'
                        />
                    </span>
                    <img
                        src={`${process.env.PUBLIC_URL}/img/footer/steam_white.svg`}
                        alt='STEAM'
                        className='f-logo'
                        id='STEAM'
                    />
                    <img src={`${process.env.PUBLIC_URL}/img/footer/gog.png`} alt='GOG' className='f-logo' id='GOG' />
                    <a href='http://nisamerica.com/' target='_blank' rel='noreferrer'>
                        <img
                            src={`${process.env.PUBLIC_URL}/img/footer/NIS_logo.webp`}
                            alt='NIS America'
                            className='f-logo fun'
                            id='NISA'
                        />
                    </a>
                    <img
                        src={`${process.env.PUBLIC_URL}/img/footer/logo_falcom.png`}
                        alt='Falcom'
                        className='f-logo'
                        id='FALCOM'
                    />
                </div>
                <p>
                    © Nihon Falcom Corporation. All Rights Reserved. Licensed to and published by NIS America, Inc.
                    <br />
                    ©2022 Sony Interactive Entertainment LLC. “<span className='SIE'>1</span>”, "PlayStation", "
                    <span className='SIE'>5</span>”, "PS5", "<span className='SIE'>4</span>”, "PS4", "
                    <span className='SIE'>0</span>” and "Play Has No Limits" are registered trademarks or trademarks of
                    Sony Interactive Entertainment Inc.
                    <br />
                    Nintendo Switch is a trademark of Nintendo.
                    <br />
                    © 2022 Valve Corporation. Steam and the Steam logo are trademarks and/or registered trademarks of
                    Valve corporation in the US and/or other countries. All rights reserved.
                    <br />
                    The rating icon is a trademark of the Entertainment Software Association. All other trademarks are
                    properties of their respective owners.
                </p>
            </div>
        </footer>
    )
}

export default Footer
